"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _useDebounce = _interopRequireDefault(require("../../hooks/use-debounce"));

var _flex = _interopRequireDefault(require("../../styles-common/flex"));

var _flexController = _interopRequireDefault(require("../../styles-common/flex-controller"));

var _slider = _interopRequireDefault(require("../slider"));

var _formLabel = _interopRequireDefault(require("../../styles-common/form-label"));

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

var _input = _interopRequireDefault(require("../../styles-common/input"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DonutRadius = function DonutRadius(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 1 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 150 : _ref$max,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 40 : _ref$value,
      _ref$minDistance = _ref.minDistance,
      minDistance = _ref$minDistance === void 0 ? 1 : _ref$minDistance,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function (data) {} : _ref$onChange;

  var _ref2 = (0, _react.useState)({
    value: value,
    key: null
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      localValue = _ref3[0],
      setLocalValue = _ref3[1];

  var changeValue = function changeValue(data) {
    setLocalValue(data);
    debounceOnChange(data);
  };

  var debounceOnChange = (0, _debounce["default"])(function (q) {
    onChange(q.value, q.key);
  }, 1000);
  return _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "options-donut-radius"
  }, "Donut radius"), _react["default"].createElement(_flex["default"], {
    row: true
  }, _react["default"].createElement(_flexController["default"], {
    contain: 20
  }, _react["default"].createElement(_input["default"], {
    value: localValue.value,
    type: "number",
    name: "options-donut-radius",
    onChange: function onChange(e) {
      return changeValue({
        value: e.target.value,
        key: "donut-radius"
      });
    }
  })), _react["default"].createElement(_flexController["default"], {
    contain: 80
  }, _react["default"].createElement(_slider["default"], {
    min: min,
    max: max,
    value: localValue.value,
    onChange: function onChange(v) {
      return changeValue({
        value: v,
        key: null
      });
    }
  }))));
};

var _default = DonutRadius;
exports["default"] = _default;